var SupportMultipleQtyPopupView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportTradeInServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportTradeInServiceActionView = (function(superClass) {
  extend(SupportTradeInServiceActionView, superClass);

  function SupportTradeInServiceActionView() {
    return SupportTradeInServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportTradeInServiceActionView.prototype.id = 'trade_in';

  SupportTradeInServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportTradeInServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportTradeInServiceActionView.prototype.toHash = function() {
    var hash, ref;
    hash = {
      service_action_id: "trade_in",
      service_action: ((ref = this.order.groupons) != null ? ref.length : void 0) > 1 ? I18n.t("js.modules.support.trade_in_vouchers") : I18n.t("js.modules.support.trade_in_voucher")
    };
    return this.extendHash(hash);
  };

  SupportTradeInServiceActionView.prototype.actionHandler = function(event) {
    var args, currentOrder, multipleQtyPopup, ref, ref1;
    currentOrder = Groupon.Support.currentOrder;
    if (window.showMultiReturnItemPopup && ((ref = currentOrder.groupons) != null ? ref.length : void 0) > 1) {
      args = {
        orders: this.order,
        serviceActionName: 'trade_in',
        singleActionButtonCallback: this.getUrlForVoucher,
        groupActionButtonCallback: this.getUrlForAllVouchers,
        showgroupActionButton: false,
        title: I18n.t("js.modules.support.trade_in_vouchers"),
        singleActionButtonName: I18n.t("js.modules.support.trade_in_voucher"),
        groupActionButtonName: I18n.t("js.modules.support.trade_in_vouchers")
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    } else {
      openLocation(this.getUrlForVoucher((ref1 = this.order.groupons) != null ? ref1[0] : void 0));
    }
    return true;
  };

  SupportTradeInServiceActionView.prototype.getUrlForAllVouchers = function(order_id) {
    return null;
  };

  SupportTradeInServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    var url;
    url = "/users/" + currentUser.id + "/groupons/vouchers/" + groupon.id + "?show_tradein=true&source=customer_support";
    return url;
  };

  SupportTradeInServiceActionView.prototype.events = {
    "click #trade_in": "actionHandler"
  };

  return SupportTradeInServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportTradeInServiceActionView;

//# sourceMappingURL=data:application/json;base64,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
